import axios from 'axios'
import { createPrefix } from 'utils/create-prefix'

export class AdminEventService {
  constructor() {
    this.endpoints = {
      ...createPrefix('/admin', {
        events: '/events',
      }),
    }
  }

  static create() {
    return new AdminEventService()
  }

  async queryEvents(params) {
    const servicePath = this.endpoints.search()
    const { data } = await axios.get(servicePath, { params })
    return data
  }

  async createEvent(eventDTO) {
    const servicePath = this.endpoints.events()
    const { data } = await axios.post(servicePath, eventDTO)
    return data
  }
}
